import { useState, useCallback } from "react";
import callApi from "./CallApi";

const UseApi = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async ({ endPoint, method = "get", data: body = null }) => {
  console.log("useApidata", endPoint ,method , data );    

    setLoading(true);
    setError(null);
    try {
      const result = await callApi({ endPoint, method, data: body });
      setData(result);
      return result;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);
  console.log("useApidata", request);    

  return { data, loading, error, request };
};

export default UseApi;